import { ConfirmDialog, notify } from "@/components/kit";
import { useDeleteKeyword } from "@/hooks/api/keyword/useDeleteKeyword";
import { Keyword } from "@/types/keyword";

interface KeywordDeleteModalProps {
  isOpen: boolean;
  onClose: () => void;
  keyword?: Keyword;
}

const KeywordDeleteModal = ({
  isOpen,
  onClose,
  keyword,
}: KeywordDeleteModalProps) => {
  const { mutate: deleteKeyword, isPending: isDeletingKeyword } =
    useDeleteKeyword();
  const handleDelete = () => {
    deleteKeyword(keyword!.id, {
      onSuccess: () => {
        onClose();
        notify.success("Keyword deleted successfully");
      },
      onError: (error) => {
        console.error(error);
        notify.error("Failed to delete keyword", "Please try again");
      },
    });
  };

  return (
    <ConfirmDialog
      confirmLabel="Delete"
      isOpen={isOpen}
      isPending={isDeletingKeyword}
      title="Delete Keyword"
      onClose={onClose}
      onConfirm={handleDelete}
    >
      <p className="text-sm">
        You're about to delete keyword{" "}
        <span className="font-semibold">{keyword?.keyword}</span>
      </p>
      <p className="text-muted mt-1 text-sm">
        Total number of products: {keyword?.products.length}
      </p>
    </ConfirmDialog>
  );
};

export default KeywordDeleteModal;
